import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MissionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllMission() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Mission
    });
    return await firstValueFrom(observable);
  }

  async createMission(name) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Mission
    }, {
      name: name
    });
    return await firstValueFrom(observable);
  }

  updateMission(id, name) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Mission
    }, {
      id: id,
      name: name
    });
    return firstValueFrom(observable);
  } 
}
